/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryLookupResponseDto
 */
export interface CategoryLookupResponseDto {
    /**
     * Category ID
     * @type {number}
     * @memberof CategoryLookupResponseDto
     */
    id: number;
    /**
     * Unique category code
     * @type {string}
     * @memberof CategoryLookupResponseDto
     */
    code: string;
    /**
     * Category name in English
     * @type {string}
     * @memberof CategoryLookupResponseDto
     */
    nameEn: string;
    /**
     * Category name in Arabic
     * @type {string}
     * @memberof CategoryLookupResponseDto
     */
    nameAr: string | null;
    /**
     * Category description
     * @type {string}
     * @memberof CategoryLookupResponseDto
     */
    description: string | null;
    /**
     * Category image URL
     * @type {string}
     * @memberof CategoryLookupResponseDto
     */
    imageUrl: string | null;
    /**
     * Whether the category is active
     * @type {boolean}
     * @memberof CategoryLookupResponseDto
     */
    isActive: boolean;
    /**
     * Sort order for display
     * @type {number}
     * @memberof CategoryLookupResponseDto
     */
    sortOrder: number | null;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof CategoryLookupResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof CategoryLookupResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CategoryLookupResponseDto interface.
 */
export function instanceOfCategoryLookupResponseDto(value: object): value is CategoryLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CategoryLookupResponseDtoFromJSON(json: any): CategoryLookupResponseDto {
    return CategoryLookupResponseDtoFromJSONTyped(json, false);
}

export function CategoryLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'],
        'description': json['description'],
        'imageUrl': json['imageUrl'],
        'isActive': json['isActive'],
        'sortOrder': json['sortOrder'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function CategoryLookupResponseDtoToJSON(value?: CategoryLookupResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

